import {createContext, useContext, useReducer, useRef, useState} from 'react';
import {TokenContext} from "./TokenContext";
import {Dialog, DialogTitle} from "@mui/material";

const LayoutDashbordContext = createContext(null)
//                                                                         ready, value, send
// Make sure to put WebsocketProvider higher up in
// the component tree than any consumer.
// let ws = null

// Disposition par défaut proposée à un utilisateur qui n'a encore rien personnalisé
// (aucune entrée `dashboardLayout_*` en localStorage) : met en avant les tickets
// support/commercial en priorité, suivis de l'activité et des dernières commandes.
const DEFAULT_LAYOUTS = {
    desktop: [
        { i: 'welcome-clock', x: 0, y: 0, w: 12, h: 4, minW: 3, minH: 4 },
        { i: 'tickets-support', x: 0, y: 4, w: 6, h: 5, minW: 3, minH: 4 },
        { i: 'tickets-commercial', x: 6, y: 4, w: 6, h: 5, minW: 3, minH: 4 },
        { i: 'activity-recent', x: 0, y: 9, w: 6, h: 5, minW: 3, minH: 5 },
        { i: 'table-orders', x: 6, y: 9, w: 6, h: 5, minW: 5, minH: 4 },
    ],
    tablet: [
        { i: 'welcome-clock', x: 0, y: 0, w: 6, h: 4, minW: 3, minH: 4 },
        { i: 'tickets-support', x: 0, y: 4, w: 6, h: 5, minW: 3, minH: 4 },
        { i: 'tickets-commercial', x: 0, y: 9, w: 6, h: 5, minW: 3, minH: 4 },
        { i: 'activity-recent', x: 0, y: 14, w: 6, h: 5, minW: 3, minH: 5 },
        { i: 'table-orders', x: 0, y: 19, w: 6, h: 5, minW: 5, minH: 4 },
    ],
    mobile: [
        { i: 'welcome-clock', x: 0, y: 0, w: 6, h: 4, minW: 3, minH: 4 },
        { i: 'tickets-support', x: 0, y: 4, w: 6, h: 5, minW: 3, minH: 4 },
        { i: 'tickets-commercial', x: 0, y: 9, w: 6, h: 5, minW: 3, minH: 4 },
        { i: 'activity-recent', x: 0, y: 14, w: 6, h: 5, minW: 3, minH: 5 },
        { i: 'table-orders', x: 0, y: 19, w: 6, h: 5, minW: 5, minH: 4 },
    ],
};

function LayoutDashbordProvider({children}) {

    const [layout, setLayout] = useState(DEFAULT_LAYOUTS);

    return (
        <LayoutDashbordContext.Provider
            value={{layout, setLayout }}>

            {children}
        </LayoutDashbordContext.Provider>
    );
};

export {LayoutDashbordContext, LayoutDashbordProvider};
